export default __webpack_public_path__ + "static/img_interviewee_blee@2x-537e52b0a9aebf94114c2f25631e16a6.png";